import { gql } from '@apollo/client';

export const updatePlcAlarmCode = gql`
  mutation updatePlcAlarmCode($id: String, $input: CreateOrUpdatePlcAlarmCode) {
    updatePlcAlarmCode(id: $id, input: $input) {
      id
      alarmCode
      alarmComment
      alarmExplanation
      alarmFix
      createdBy
      createdAt
      updater
      updatedAt
      deletedAt
    }
  }
`;
